/* Bastant site 2026 — content pages (area "page"): form validation, form message focus, click-to-play video, copy link. */
(() => {
  if (window.bsPageInit) return;
  window.bsPageInit = true;

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function fieldOk(input) {
    const value = (input.value || '').trim();
    if (input.required && !value) return false;
    if (input.type === 'email' && value && !EMAIL.test(value)) return false;
    return true;
  }

  function setState(input, ok) {
    const field = input.closest('.bs-pg-field');
    if (field) field.classList.toggle('is-invalid', !ok);
    if (ok) input.removeAttribute('aria-invalid');
    else input.setAttribute('aria-invalid', 'true');
  }

  function bindForm(form) {
    if (form.dataset.bsBound) return;
    form.dataset.bsBound = '1';
    form.setAttribute('novalidate', '');

    form.addEventListener('input', (event) => {
      const input = event.target;
      if (input.closest('.bs-pg-field.is-invalid') && fieldOk(input)) setState(input, true);
    });
    form.addEventListener('focusout', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
      if ((input.value || '').trim() && !fieldOk(input)) setState(input, false);
    });
  }

  // Validate in the capture phase on document, so an invalid form never reaches Shopify's own submit
  // handlers (e.g. the captcha challenge) — the visitor sees our field messages first.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-bs-validate]')) return;
    let first = null;
    Array.from(form.querySelectorAll('input[required], textarea[required], select[required], input[type="email"]')).forEach((input) => {
      const ok = fieldOk(input);
      setState(input, ok);
      if (!ok && !first) first = input;
    });
    if (first) {
      event.preventDefault();
      event.stopImmediatePropagation();
      first.focus();
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      // Shopify may show a captcha before posting; release the button if the visitor closes it.
      setTimeout(() => button.removeAttribute('aria-busy'), 6000);
    }
  }, true);

  function initForms(root = document) {
    root.querySelectorAll('[data-bs-validate] form').forEach(bindForm);
    const msg = root.querySelector('[data-bs-focus]');
    if (msg && !msg.dataset.bsFocused) {
      msg.dataset.bsFocused = '1';
      msg.scrollIntoView({ block: 'center' });
      msg.focus({ preventScroll: true });
    }
  }

  function initVideos(root = document) {
    root.querySelectorAll('[data-bs-video]').forEach((wrap) => {
      if (wrap.dataset.bsBound) return;
      wrap.dataset.bsBound = '1';
      const button = wrap.querySelector('.bs-pg-video__play');
      const tpl = wrap.querySelector('template[data-bs-video-src]');
      if (!button || !tpl) return;
      button.addEventListener('click', () => {
        const frame = wrap.querySelector('.bs-pg-video__frame');
        frame.appendChild(tpl.content.cloneNode(true));
        wrap.classList.add('is-playing');
        const video = frame.querySelector('video');
        if (video) {
          video.play().catch(() => {});
          video.focus();
        }
      });
    });
  }

  function initCopy(root = document) {
    root.querySelectorAll('[data-bs-copy]').forEach((btn) => {
      if (btn.dataset.bsBound) return;
      btn.dataset.bsBound = '1';
      const label = btn.textContent;
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(btn.dataset.bsCopy);
          btn.textContent = btn.dataset.bsCopied || 'Kopieret';
          setTimeout(() => { btn.textContent = label; }, 2000);
        } catch (e) {
          window.prompt('Kopiér linket:', btn.dataset.bsCopy);
        }
      });
    });
  }

  function init(root) {
    initForms(root);
    initVideos(root);
    initCopy(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
